export const FETCH_SEGMENTS = 'FETCH_SEGMENTS';
export const FETCH_SEGMENTS_SUCCESS = 'FETCH_SEGMENTS_SUCCESS';
export const FETCH_SEGMENTS_FAIL = 'FETCH_SEGMENTS_FAIL';
export const PROCEED_SCREENING = 'PROCEED_SCREENING';
export const PROCEED_SCREENING_SUCCESS = 'PROCEED_SCREENING_SUCCESS';
export const PROCEED_SCREENING_FAIL = 'PROCEED_SCREENING_FAIL';
export const RESET_SIGNLE_SCREENING = 'RESET_SIGNLE_SCREENING';
export const SHOW_SCANNING_MODAL = 'SHOW_SCANNING_MODAL';
export const SHOW_SCREENING_MODAL = 'SHOW_SCREENING_MODAL';
export const STOP_BULK_SCREENING_LOCAL = 'STOP_BULK_SCREENING_LOCAL';
export const SCAN_UPLOADED_FILE = 'SCAN_UPLOADED_FILE';
export const SCAN_UPLOADED_FILE_SUCCESS = 'SCAN_UPLOADED_FILE_SUCCESS';
export const SCAN_UPLOADED_FILE_FAILED = 'SCAN_UPLOADED_FILE_FAILED';
export const SET_UPLOADED_FILE = 'SET_UPLOADED_FILE';
export const PROCEED_BULK_SCREENING = 'PROCEED_BULK_SCREENING';
export const PROCEED_BULK_SCREENING_SUCCESS = 'PROCEED_BULK_SCREENING_SUCCESS';
export const PROCEED_BULK_SCREENING_FAIL = 'PROCEED_BULK_SCREENING_FAIL';
export const GET_OD_NS_HISTORY_DOWNLOAD_CSV = 'GET_OD_NS_HISTORY_DOWNLOAD_CSV';
export const GET_OD_NS_HISTORY_DOWNLOAD_CSV_SUCCESS =
  'GET_OD_NS_HISTORY_DOWNLOAD_CSV_SUCCESS';
export const GET_OD_NS_HISTORY_DOWNLOAD_CSV_FAIL =
  'GET_OD_NS_HISTORY_DOWNLOAD_CSV_FAIL';
export const RESET_OD_NS_HISTORY_DOWNLOAD_CSV =
  'RESET_OD_NS_HISTORY_DOWNLOAD_CSV';
export const GET_SCREENING_PROGRESS = 'GET_SCREENING_PROGRESS';
export const GET_SCREENING_PROGRESS_SUCCESS = 'GET_SCREENING_PROGRESS_SUCCESS';
export const GET_SCREENING_PROGRESS_FAIL = 'GET_SCREENING_PROGRESS_FAIL';
export const STOP_BULK_SCREENING = 'STOP_BULK_SCREENING';
export const STOP_BULK_SCREENING_SUCCESS = 'STOP_BULK_SCREENING_SUCCESS';
export const STOP_BULK_SCREENING_FAIL = 'STOP_BULK_SCREENING_FAIL';
export const SET_SCREENING_PERCENT = 'SET_SCREENING_PERCENT';
export const SELECTED_ALERT_IDS = 'SELECTED_ALERT_IDS';
export const SELECTED_ALERT_FILTERS = 'SELECTED_ALERT_FILTERS';
export const FETCH_MATCHING_CONFIGS = 'FETCH_MATCHING_CONFIGS';
export const FETCH_MATCHING_CONFIGS_SUCCESS = 'FETCH_MATCHING_CONFIGS_SUCCESS';
export const FETCH_MATCHING_CONFIGS_FAIL = 'FETCH_MATCHING_CONFIGS_FAIL';
export const UPDATE_ALERT_LIST_PAGE = 'UPDATE_ALERT_LIST_PAGE';
export const UPDATE_ALERT_LIST_PAGE_SIZE = 'UPDATE_ALERT_LIST_PAGE_SIZE';

export const fetchSegmentsList = () => ({
  type: FETCH_SEGMENTS
});

export const fetchSegmentsListSuccess = (segments) => ({
  type: FETCH_SEGMENTS_SUCCESS,
  payload: segments
});

export const fetchSegmentsListFail = (message) => ({
  type: FETCH_SEGMENTS_FAIL,
  payload: message
});

export const proceedScreening = ({ screeningData }) => ({
  type: PROCEED_SCREENING,
  payload: { screeningData }
});

export const proceedScreeningSuccess = ({ alertId }) => ({
  type: PROCEED_SCREENING_SUCCESS,
  payload: { alertId }
});

export const proceedScreeningFail = (message) => ({
  type: PROCEED_SCREENING_FAIL,
  payload: message
});

export const resetSingleScreening = () => ({
  type: RESET_SIGNLE_SCREENING
});

export const showScanningPopup = (payload) => ({
  type: SHOW_SCANNING_MODAL,
  payload
});

export const showScreeningPopup = (payload) => ({
  type: SHOW_SCREENING_MODAL,
  payload
});

export const stopBulkScreeningLocal = () => ({
  type: STOP_BULK_SCREENING_LOCAL
});

export const scanUploadedFile = ({ file }) => ({
  type: SCAN_UPLOADED_FILE,
  payload: { file }
});

export const scanUploadedFileSuccess = ({
  jobId,
  totalCount,
  invalidData
}) => ({
  type: SCAN_UPLOADED_FILE_SUCCESS,
  payload: { jobId, totalCount, invalidData }
});

export const scanUploadedFileFailed = (message) => ({
  type: SCAN_UPLOADED_FILE_FAILED,
  payload: message
});

export const setUploadedFile = (file) => ({
  type: SET_UPLOADED_FILE,
  payload: file
});

export const proceedBulkScreening = ({ jobId }) => ({
  type: PROCEED_BULK_SCREENING,
  payload: { jobId }
});

export const bulkScreeningSuccess = () => ({
  type: PROCEED_BULK_SCREENING_SUCCESS
});

export const bulkScreeningFail = (message) => ({
  type: PROCEED_BULK_SCREENING_FAIL,
  payload: message
});

export function getODNSHistoryCsvDownload(payload) {
  return {
    type: GET_OD_NS_HISTORY_DOWNLOAD_CSV,
    payload
  };
}

export function getODNSHistoryCsvDownloadSuccess(payload) {
  return {
    type: GET_OD_NS_HISTORY_DOWNLOAD_CSV_SUCCESS,
    payload
  };
}

export function getODNSHistoryCsvDownloadFail(payload) {
  return {
    type: GET_OD_NS_HISTORY_DOWNLOAD_CSV_FAIL,
    payload
  };
}

export function resetODNSHistoryCsvDownload(payload) {
  return {
    type: RESET_OD_NS_HISTORY_DOWNLOAD_CSV,
    payload
  };
}
export const getScreeningProgress = ({ jobId }) => ({
  type: GET_SCREENING_PROGRESS,
  payload: { jobId }
});

export const getScreeningProgressSuccess = ({ screenedRecordCount }) => ({
  type: GET_SCREENING_PROGRESS_SUCCESS,
  payload: { screenedRecordCount }
});

export const getScreeningProgressFail = (message) => ({
  type: GET_SCREENING_PROGRESS_FAIL,
  payload: message
});

export const stopBulkScreening = ({ jobId }) => ({
  type: STOP_BULK_SCREENING,
  payload: { jobId }
});

export const stopBulkScreeningSuccess = () => ({
  type: STOP_BULK_SCREENING_SUCCESS
});

export const stopBulkScreeningFail = (message) => ({
  type: STOP_BULK_SCREENING_FAIL,
  payload: message
});

export const setScreeningPercent = (percent) => ({
  type: SET_SCREENING_PERCENT,
  payload: percent
});

export const selectedAlertIds = ({ selectedIds, selectedAlerts }) => ({
  type: SELECTED_ALERT_IDS,
  payload: { selectedIds, selectedAlerts }
});

export const selectedAlertFilters = (filter) => ({
  type: SELECTED_ALERT_FILTERS,
  payload: filter
});

export const fetchMatchingConfigs = ({ runInstanceId }) => ({
  type: FETCH_MATCHING_CONFIGS,
  payload: { runInstanceId }
});

export const fetchMatchingConfigsSuccess = (matchingConfigs) => ({
  type: FETCH_MATCHING_CONFIGS_SUCCESS,
  payload: matchingConfigs
});

export const fetchMatchingConfigsFail = (message) => ({
  type: FETCH_MATCHING_CONFIGS_FAIL,
  payload: message
});

export const updateAlertListPage = (currentPage) => ({
  type: UPDATE_ALERT_LIST_PAGE,
  payload: currentPage
});

export const updateAlertListPageSize = (size) => ({
  type: UPDATE_ALERT_LIST_PAGE_SIZE,
  payload: size
});
